/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'star-rating',
};
